import { ReactNode } from 'react';
import { withStyles } from 'vopay';
import Header from '@/components/Accounts/AccountCreation/R1AccountCreation/Header/Header';
import StepIndicator from '@/components/Accounts/AccountCreation/R1AccountCreation/StepIndicator/StepIndicator';

import styles from './StepShell.module.scss';

const cn = withStyles(styles);

type StepShellProps = {
  title: ReactNode;
  description: ReactNode;
  steps: string[];
  currentStep: number;
  children: ReactNode;
  footer: ReactNode;
};

export default function StepShell({ title, description, steps, currentStep, children, footer }: StepShellProps) {
  return (
    <div className={cn('container')}>
      <div className={cn('stickyHeader')}>
        <Header
          header={title}
          description={description}
          rightArea={<StepIndicator steps={steps} activeStep={currentStep} />}
        />
      </div>

      <div className={cn('body')}>{children}</div>
      <div className={cn('footer')}>{footer}</div>
    </div>
  );
}
